import { SettingStoreActions, SettingStoreMutations } from "@/constants/store/setting/settingStoreConstants";
import { Setting } from "@/dataModel";

export default {
  [SettingStoreActions.SET_AI_SETTING]({ commit }: { commit: Function }, setting: Setting): void {
    commit(SettingStoreMutations.SET_AI_SETTING, setting);
  },
};
